import {useEffect} from 'react';
import {Canvas} from '@postermywall/fabricjs-2';
import type {StockDropPosition} from '@Panels/stock-panel/stock-drag-controller';
import {registerStockDropResolver} from '@Panels/stock-panel/stock-drag-controller';

/**
 * Resolves where a dragged stock item should land: the poster-space point under the pointer, but only when
 * the release lands on the current page's canvas. Hit-tests the topmost element under the pointer (not just
 * the canvas rectangle) so a drop over the stock panel — which can overlap the canvas on narrow screens — is
 * rejected. Returns null for releases anywhere else (so nothing is added).
 */
const resolveDropPoint = (e: PointerEvent): StockDropPosition | null => {
  const page = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!page) {
    return null;
  }
  const canvas = page.fabricCanvas;
  if (!(canvas instanceof Canvas)) {
    return null;
  }
  const topElement = document.elementFromPoint(e.clientX, e.clientY);
  if (!topElement || !page.canvasBackdrop.contains(topElement)) {
    return null;
  }
  const scenePoint = canvas.getScenePoint(e);
  return {left: scenePoint.x, top: scenePoint.y};
};

/** Lets a stock-panel item dragged onto the poster canvas drop at the cursor position (current page only). */
export function useStockItemDropTarget(): void {
  useEffect(() => {
    return registerStockDropResolver(resolveDropPoint);
  }, []);
}
